module.exports = __webpack_public_path__ + "media/icons/cancel-ff079732.svg";